



















































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositFixedTermSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositFixedTermSettings';
import AccountDepositFixedTermSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTerm/AccountDepositFixedTermSettingsEditDialog.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositFixedTermSettingsRead', components: { AccountDepositFixedTermSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    settings: AccountDepositFixedTermSettings;

    PermissionUtils = PermissionUtils;

    async deleteDepositFixedTermSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositFixedTermSettings();
        }
    }


}
